import Actions from '../../../constants/Actions.js';

function passContextToAuditStore(context) {
  context.dispatch(Actions.AUDIT__CONTEXT_PASSED, context);
}

const queryTypes = {
  getAuditData: 'DATA_QUERY',
  getCsvData: 'CSV_DOWNLOAD_QUERY'
};

// common service call execution across all query types
async function execute({ context, type, filters}) {
  const rootAction = queryTypes[type];
  context.dispatch(Actions[`AUDIT_DASHBOARD__${ rootAction }_STARTED`]);

  return await context.service.read('audit', { type, filters })
    .then((response) => {
      if (!response || !response.data) {
        const err = new Error(`unexpected result format using filters: ${ JSON.stringify(filters) }`);
        context.dispatch(Actions[`AUDIT_DASHBOARD__${ rootAction }_FAILED`], err);
        return err;
      }

      const data = response.data;

      // instantiate Date objects for event timestamps
      if (Array.isArray(data.events)) {
        data.events = data.events.map((event) => {
          event.timestamp = new Date(event.timestamp);
          return event;
        });
      }

      context.dispatch(Actions[`AUDIT_DASHBOARD__${ rootAction }_COMPLETED`], data);
      return response.data;
    })
    .catch((err) => {
      context.dispatch(Actions[`AUDIT_DASHBOARD__${ rootAction }_FAILED`], err);
      return err;
    });
}

async function queryAuditData(context, filters) {
  return await execute({ type: 'getAuditData', context, filters });
}

// this one is called via action context so as to allow for async return of data to caller
async function queryCsvData(context, filters, done) {
  const result = await execute({ type: 'getCsvData', context, filters });

  if (result instanceof Error) {
    return done(result);
  }

  return done(null, result);
}

export {
  passContextToAuditStore,
  queryAuditData,
  queryCsvData
};



// WEBPACK FOOTER //
// ./src/apps/Audit/actions/AuditActionCreators.js